export { default, type AnimatedSpinnerProps } from './AnimatedSpinner';
